import { RootState, ThunkDispatch } from "core-integration/src/store";
import {
  cancelActiveChip,
  cancelProposedChip,
  proposeAvailableChip,
  restoreCancelledChip,
} from "core-integration/src/store/chips/actions";
import {
  getActiveChip,
  getActiveOrProposedTeamChipName,
  getPotentialChips,
  teamChipsHaveChanged,
} from "core-integration/src/store/chips/reducers";
import { IPotentialChip } from "core-integration/src/store/chips/types";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import {
  IElement,
  IElementsById,
} from "core-integration/src/store/elements/types";
import { getEntry } from "core-integration/src/store/entries/reducers";
import { fetchEntrySummary } from "core-integration/src/store/entries/thunks";
import { IPickLight } from "core-integration/src/store/entries/types";
import { getNextEvent } from "core-integration/src/store/events/reducers";
import { getFixturesForNextEventByTeam } from "core-integration/src/store/fixtures/reducers";
import { IFixturesForEventByTeam } from "core-integration/src/store/fixtures/types";
import { getRules } from "core-integration/src/store/game/reducers";
import { IRules } from "core-integration/src/store/game/types";
import {
  changeCaptain,
  changeViceCaptain,
} from "core-integration/src/store/my-team/actions";
import {
  getMyFormation,
  getMyPicksProposed,
  getMyTeamSavingState,
  hasMyTeamChanged,
  isMyTeamValid,
} from "core-integration/src/store/my-team/reducers";
import {
  actionSubstitution,
  fetchMyTeam,
  saveMyTeam,
} from "core-integration/src/store/my-team/thunks";
import { IPickProposed } from "core-integration/src/store/my-team/types";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { ILoggedInPlayer } from "core-integration/src/store/player/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { ITeamsById } from "core-integration/src/store/teams/types";
import {
  formatRawAsISO,
  formatRawAsLocalI18n,
} from "core-integration/src/utils/datetime";
import { range } from "lodash";
import { size } from "polished";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "rebass/styled-components";
import styled from "styled-components";
import ArrowRight from "../../img/icons/arrow-right.svg?react";
import { ChipName, getAllChipDetails } from "../../utils/chips";
import Alert from "../Alert";
import Button from "../Button";
import DeadlineBar from "../DeadlineBar";
import Dialog, { DialogButtonItem } from "../Dialog";
import Entry from "../Entry";
import { FixturesForElement } from "../FixtureForElement";
import Fixtures from "../Fixtures";
import { Main, Secondary, Wrapper } from "../Layout";
import Link from "../Link";
import { ElementRow } from "../Pitch";
import DreamTeam from "../icons/DreamTeam";
// import ShirtSoonAlert from "../ShirtSoonAlert";
import { getProposedElements } from "core-integration/src/store/squad/reducers";
import { useEffect, useState } from "react";
import { useBlocker } from "react-router";
import { dateLocales } from "../../i18n";
import AttackAttack from "../../img/icons/attack-attack.svg?react";
import DoubleCaptain from "../../img/icons/double-captain.svg?react";
import ParkBus from "../../img/icons/park-the-bus.svg?react";
import Title from "../Title";
import Tooltip, { TooltipLabel } from "../Tooltip";
import UnsavedChangesDialog from "../UnsavedChangesDialog";
import SaveBar from "../squad/SaveBar";
import TabPanel from "../tabs/TabPanel";
import Tabs from "../tabs/Tabs";
import BenchUnit from "./BenchUnit";
import MyTeamTable from "./MyTeamTable";
import PitchFormation from "./PitchFormation";
import PitchWrapper from "./PitchWrapper";

const TableWrap = styled.div`
  margin: ${({ theme }) => theme.space[2]} 0;
`;

const ChipList = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space[1]};
  margin: ${({ theme }) => `${theme.space[4]}  ${theme.space[1]}`};
  padding: ${({ theme }) =>
    `${theme.space[0]} ${theme.space[0]} ${theme.space[4]}`};
  list-style-type: none;

  @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
    justify-content: space-evenly;
    gap: ${({ theme }) => theme.space[2]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    margin: ${({ theme }) => `${theme.space[4]}  ${theme.space[2]}`};
    padding: ${({ theme }) =>
      `${theme.space[2]} ${theme.space[2]} ${theme.space[4]}`};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    gap: ${({ theme }) => theme.space[4]};
    padding: 0;
    margin: ${({ theme }) =>
      `${theme.space[4]} ${theme.space[0]} ${theme.space[7]}`};
  }
`;

const ChipItem = styled.li`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space[2]};
  max-width: 115px;
  padding: ${({ theme }) => theme.space[3]};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.radii[0]};
  background-color: ${({ theme }) => theme.colors.bgWhiteOpacity50};
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
    max-width: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    gap: ${({ theme }) => theme.space[3]};
  }
`;

const ChipIcon = styled.div`
  svg {
    width: 60px;
    height: 60px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    svg {
      width: 73px;
      height: 73px;
    }
  }
`;

const ChipHeading = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: ${({ theme }) => theme.fontSizes[2]};
  font-weight: 600;
  text-align: center;
`;

const ChipLink = styled(Link)`
  position: relative;
  display: block;
  width: 100%;
  padding: 0.9rem 1.7rem;
  border-radius: 30px;
  background-color: ${({ theme }) => theme.colors.greyDarker2};
  color: ${({ theme }) => theme.colors.black};

  :hover {
    text-decoration: none;
  }
`;

const ChipTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: ${({ theme }) => theme.fonts.baseSemiBold};

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    flex-direction: row;
  }
`;

const ChipPointsLink = styled.div`
  color: ${({ theme }) => theme.colors.red};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    display: none;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    display: block;
  }
`;

const ChipLinkArrowWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[1]};
`;

const ChipLinkArrow = styled(ArrowRight)`
  ${size(10)};
  fill: currentColor;
  color: ${({ theme }) => theme.colors.red};
  cursor: pointer;
`;

const renderPickValue =
  (initProps: {
    elementsById: IElementsById;
    fixturesForNextEventByTeam: IFixturesForEventByTeam;
    teamsById: ITeamsById;
  }) =>
  (pick: IPickLight) => {
    const element = initProps.elementsById[pick.element];
    return (
      <FixturesForElement
        fixtures={initProps.fixturesForNextEventByTeam[element.team]}
        element={element}
        teamsById={initProps.teamsById}
      />
    );
  };

const PlayerName = styled.div`
  border-radius: ${({ theme }) => theme.radii[0]};
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: 24px;
  font-weight: 600;
  line-height: 1;
`;

const PlayerActions = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    width: 50%;
    margin: 0 auto;
  }
`;

type Props = WithTranslation;

const MyTeam = ({ i18n, t }: Props) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const [pickForMenu, setPickForMenu] = useState<IPickProposed | null>(null);

  const picks = useSelector(getMyPicksProposed);
  const elementsById = useSelector(getElementsById);
  const rules = useSelector(getRules) as IRules;
  const player = useSelector(getPlayerData) as ILoggedInPlayer;
  const activeChip = useSelector(getActiveChip);
  const chipInPlayName = useSelector(getActiveOrProposedTeamChipName);
  const changed = useSelector(hasMyTeamChanged);
  const chips = useSelector(getPotentialChips);
  const chipsChanged = useSelector(teamChipsHaveChanged);
  const entry = useSelector((state: RootState) =>
    getEntry(state, player.entry),
  );
  const fixturesForNextEventByTeam = useSelector(getFixturesForNextEventByTeam);
  const formation = useSelector(getMyFormation);
  const nextEvent = useSelector(getNextEvent);
  const savingState = useSelector(getMyTeamSavingState);
  const teamsById = useSelector(getTeamsById);
  const valid = useSelector(isMyTeamValid);
  const proposedElements = useSelector(getProposedElements);

  // useBlocker allows us to intercept navigation if a condition is met. Here we use
  // hasChanged so that if team changes have been made we ask the user to confirm
  // they are happy for changes to be lost
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    return (
      chipsChanged ||
      (Object.keys(proposedElements).length > 0 &&
        changed &&
        currentLocation.pathname !== nextLocation.pathname)
    );
  });

  const handleShowMenuForPickElement = (element: number) => {
    const matches = picks.filter((p) => p.element === element);
    if (matches.length) {
      setPickForMenu(matches[0]);
    }
  };

  const handleHideMenuForPick = () => {
    setPickForMenu(null);
  };

  const renderDreamTeam = (pick: IPickLight) =>
    elementsById[pick.element].in_dreamteam ? (
      <Link to="/dream-team/">
        <DreamTeam />
      </Link>
    ) : null;

  const action = (
    type: "substitute" | "makeCaptain" | "makeViceCaptain",
    element: number,
  ) => {
    handleHideMenuForPick();
    switch (type) {
      case "substitute":
        dispatch(actionSubstitution(element));
        break;
      case "makeCaptain":
        dispatch(changeCaptain(element));
        break;
      case "makeViceCaptain":
        dispatch(changeViceCaptain(element));
        break;
    }
  };

  const showDialog = (element: IElement) => {
    dispatch(showElementSummary(element.id));
    handleHideMenuForPick();
  };

  const renderMenu = () => {
    const pick = pickForMenu;
    if (!pick) {
      return null;
    }
    const element = elementsById[pick.element];
    const status = pick.subStatus;
    const startMax = rules.squad_squadplay;

    return (
      <Dialog closeDialog={handleHideMenuForPick}>
        <Dialog.Header closeDialog={handleHideMenuForPick}>
          <PlayerName>
            {`${element.first_name} ${element.second_name}`}
          </PlayerName>
        </Dialog.Header>
        <Dialog.Body>
          <PlayerActions>
            {status.match(/^(target|)$/) && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("substitute", pick.element)}
                  width={1}
                >
                  {t("myTeam.menuDialog.switch", "Switch")}
                </Button>
              </DialogButtonItem>
            )}
            {status === "instigator" && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("substitute", pick.element)}
                  width={1}
                >
                  {t("myTeam.menuDialog.cancel", "Cancel")}
                </Button>
              </DialogButtonItem>
            )}
            {!status && pick.position <= startMax && !pick.is_captain && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("makeCaptain", pick.element)}
                  width={1}
                >
                  {t("myTeam.menuDialog.makeCaptain", "Make Captain")}
                </Button>
              </DialogButtonItem>
            )}
            {!status && pick.position <= startMax && !pick.is_vice_captain && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("makeViceCaptain", pick.element)}
                  width={1}
                >
                  {t("myTeam.menuDialog.makeViceCaptain", "Make Vice Captain")}
                </Button>
              </DialogButtonItem>
            )}
            <DialogButtonItem>
              <Button onClick={() => showDialog(element)} width={1}>
                {t("myTeam.menuDialog.viewInfo", "View Information")}
              </Button>
            </DialogButtonItem>
          </PlayerActions>
        </Dialog.Body>
      </Dialog>
    );
  };

  useEffect(() => {
    dispatch(fetchMyTeam());
    dispatch(fetchEntrySummary(player.entry));
  }, [dispatch, player.entry]);

  const renderChipAction = (c: IPotentialChip) => {
    switch (c.status_for_entry) {
      case "available":
      case "unavailable":
        return (
          <Button
            onClick={() => dispatch(proposeAvailableChip(c.name))}
            disabled={Boolean(chipInPlayName)}
            width={1}
            variant="secondary"
          >
            {t("myTeam.play", "Play")}
          </Button>
        );
      case "proposed":
        return (
          <Button
            onClick={() => dispatch(cancelProposedChip(c.name))}
            width={1}
          >
            {t("myTeam.cancel", "Cancel")}
          </Button>
        );
      case "active":
        return (
          <Button onClick={() => dispatch(cancelActiveChip(c.name))} width={1}>
            {t("myTeam.cancel", "Cancel")}
          </Button>
        );
      case "cancelled":
        return (
          <Button
            onClick={() => dispatch(restoreCancelledChip(c.name))}
            disabled={Boolean(chipInPlayName)}
            width={1}
          >
            {t("myTeam.restore", "Restore")}
          </Button>
        );
      case "played":
        if (!entry) {
          return (
            <>
              <div>{t("myTeam.played", "Played")}</div>
              <div>{`${t("myTeam.round", "Round")} ${
                c.played_by_entry[0]
              }`}</div>
            </>
          );
        }
        return (
          <ChipLink to={`/entry/${entry.id}/event/${c.played_by_entry[0]}`}>
            <ChipTextWrap>
              <div>{`${t("myTeam.played", "Played")} ${t(
                "myTeam.round",
                "Round",
              )} ${c.played_by_entry[0]} `}</div>
              <ChipLinkArrowWrap>
                <ChipPointsLink>{t("myTeam.points", "Points")}</ChipPointsLink>
                <ChipLinkArrow />
              </ChipLinkArrowWrap>
            </ChipTextWrap>
          </ChipLink>
        );
      default:
        return "";
    }
  };

  if (!entry || !picks.length) {
    return null;
  }
  // Create a new function on each render as fixtures could have changed and
  // need to ensure a render of connected subcomponents
  const _renderPickValue = renderPickValue({
    elementsById,
    teamsById,
    fixturesForNextEventByTeam,
  });

  const benchHeading: Record<string, React.ReactNode> = {
    11: (
      <Tooltip content="Goalkeeper">
        <TooltipLabel>GK</TooltipLabel>
      </Tooltip>
    ),
    12: "1",
    13: "2",
    14: "3",
  };

  const chipDetails = getAllChipDetails(t);

  const getChipIcon = (chipName: string) => {
    switch (chipName) {
      case "2capt":
        return <DoubleCaptain />;
      case "frush":
        return <AttackAttack />;
      case "pdbus":
        return <ParkBus />;
      default:
        return null;
    }
  };

  return (
    <>
      <Wrapper>
        <Main>
          <Box mx={2}>
            <Title>{t("myTeam.title", "My Team")}</Title>
          </Box>
          {blocker.state === "blocked" && (
            <UnsavedChangesDialog
              handleConfirm={() =>
                blocker.state === "blocked" && blocker.proceed()
              }
              handleHide={() => blocker.state === "blocked" && blocker.reset()}
            />
          )}
          {nextEvent && (
            <DeadlineBar
              deadlineISO={formatRawAsISO(nextEvent.deadline_time)}
              deadlineLocal={formatRawAsLocalI18n(
                nextEvent.deadline_time,
                dateLocales[i18n.language],
              )}
              headingText={nextEvent.name}
            />
          )}
          <Box m={2}>
            <Alert type="info">
              {t(
                "myTeam.alerts.captain",
                "To change your captain use the menu which appears when clicking on a player.",
              )}
            </Alert>
          </Box>
          {savingState === "saved" ? (
            <Box my={2}>
              <Alert type="success">
                {t("myTeam.alerts.teamSaved", "Your team has been saved.")}
              </Alert>
            </Box>
          ) : (
            <SaveBar
              hasUnsavedChanges={
                (changed || chipsChanged) && valid && savingState !== "saving"
              }
              unsavedChangesText={t(
                "unsavedChanges",
                "You have unsaved changes",
              )}
            >
              <Button
                onClick={() => dispatch(saveMyTeam())}
                disabled={
                  (!changed && !chipsChanged) ||
                  !valid ||
                  savingState === "saving"
                }
                width={1}
              >
                {t("myTeam.saveTeam", "Save Your Team")}
              </Button>
            </SaveBar>
          )}
          <PitchWrapper>
            <Box pt={4}>
              <Box mx={2} mb={2}>
                <Tabs centered>
                  <TabPanel
                    label={t("myTeam.pitchView", "Pitch View")}
                    link="pitch"
                  >
                    <Box mx={-2} pt={4}>
                      <PitchFormation
                        chipName={chipInPlayName}
                        formation={formation}
                        picks={picks}
                        renderDreamTeam={renderDreamTeam}
                        renderElementMenu={handleShowMenuForPickElement}
                        renderPickValue={_renderPickValue}
                      />
                      <ElementRow>
                        {range(
                          rules.squad_squadplay,
                          rules.squad_squadsize,
                        ).map((i) => (
                          <BenchUnit
                            key={i}
                            chipName={chipInPlayName}
                            heading={benchHeading[i]}
                            pick={picks[i]}
                            renderElementMenu={() =>
                              handleShowMenuForPickElement(picks[i].element)
                            }
                            renderDreamTeam={renderDreamTeam}
                            renderPickValue={_renderPickValue}
                          />
                        ))}
                      </ElementRow>
                    </Box>
                  </TabPanel>
                  <TabPanel
                    label={t("myTeam.listView", "List View")}
                    link="list"
                  >
                    <Box mb={2}>
                      <TableWrap>
                        <MyTeamTable
                          title={t("myTeam.starters", "Starters")}
                          picks={picks.slice(0, rules.squad_squadplay)}
                          renderElementMenu={handleShowMenuForPickElement}
                        />
                      </TableWrap>
                      <TableWrap>
                        <MyTeamTable
                          title={t("myTeam.substitutes", "Substitutes")}
                          picks={picks.slice(rules.squad_squadplay)}
                          renderElementMenu={handleShowMenuForPickElement}
                        />
                      </TableWrap>
                    </Box>
                  </TabPanel>
                </Tabs>
              </Box>
            </Box>
          </PitchWrapper>
          {/* <ShirtSoonAlert /> */}
          {activeChip && activeChip.chip_type === "transfer" ? (
            <Box my={2}>
              <Alert type="info">
                <p>
                  {t("myTeam.alerts.transferChip", "{{ chipName }} Active", {
                    chipName: chipDetails[activeChip.name as ChipName].name,
                  })}
                </p>
              </Alert>
            </Box>
          ) : (
            <ChipList>
              {chips
                .filter((c) => ["2capt", "frush", "pdbus"].indexOf(c.name) > -1)
                .map((c) => (
                  <ChipItem key={c.name}>
                    <ChipIcon>{getChipIcon(c.name)}</ChipIcon>
                    <Tooltip
                      content={chipDetails[c.name as ChipName].description}
                    >
                      <ChipHeading>
                        {chipDetails[c.name as ChipName].name}
                      </ChipHeading>
                    </Tooltip>
                    {renderChipAction(c)}
                  </ChipItem>
                ))}
            </ChipList>
          )}

          {renderMenu()}
          <Fixtures />
        </Main>
        <Secondary>
          <Entry entryId={entry.id} />
        </Secondary>
      </Wrapper>
    </>
  );
};

export default withTranslation()(MyTeam);
